var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _linearGradient47, _linearGradient48, _linearGradient49, _linearGradient50, _linearGradient51, _linearGradient52, _linearGradient53, _linearGradient54, _linearGradient55, _linearGradient56, _linearGradient57, _linearGradient58, _linearGradient59, _linearGradient60, _linearGradient61, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPayphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efdcfb"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.211,
    x2: 280.219,
    xlinkHref: "#lg1",
    y1: 441.971,
    y2: 441.971
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efdcfb",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4856,
    stopColor: "#baaad6",
    stopOpacity: 0.486
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679b2"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 284.72,
    x2: 256.72,
    xlinkHref: "#lg2",
    y1: 505.238,
    y2: 416.738
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f82814"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg3",
    y1: 429,
    y2: 452.046
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.266,
    x2: 412.734,
    xlinkHref: "#lg3",
    y1: 217.526,
    y2: 217.526
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6245,
    stopColor: "#d22725",
    stopOpacity: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg4",
    y1: 395.775,
    y2: 428.818
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 416.433,
    x2: 35.844,
    xlinkHref: "#lg3",
    y1: 378.959,
    y2: -1.63
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.879,
    x2: 295.713,
    xlinkHref: "#lg4",
    y1: 424.258,
    y2: 357.091
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 152.27,
    x2: 332.265,
    xlinkHref: "#lg1",
    y1: 114.797,
    y2: 294.791
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientTransform: "matrix(-1 0 0 -1 510 1574)",
    gradientUnits: "userSpaceOnUse",
    x1: 159.371,
    x2: 326.924,
    xlinkHref: "#lg1",
    y1: 1260.845,
    y2: 1428.398
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.37,
    x2: 147.766,
    xlinkHref: "#lg2",
    y1: 168.753,
    y2: 133.15
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 159.761,
    x2: 177.237,
    xlinkHref: "#lg5",
    y1: 145.144,
    y2: 162.62
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientTransform: "matrix(-1 0 0 -1 303.25 1436.25)",
    gradientUnits: "userSpaceOnUse",
    x1: 133.772,
    x2: 144.611,
    xlinkHref: "#lg5",
    y1: 1281.389,
    y2: 1292.227
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 222.811,
    x2: 187.207,
    xlinkHref: "#lg2",
    y1: 168.753,
    y2: 133.15
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 199.202,
    x2: 216.678,
    xlinkHref: "#lg5",
    y1: 145.144,
    y2: 162.62
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientTransform: "matrix(-1 0 0 -1 303.25 1436.25)",
    gradientUnits: "userSpaceOnUse",
    x1: 94.331,
    x2: 105.17,
    xlinkHref: "#lg5",
    y1: 1281.389,
    y2: 1292.227
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 262.252,
    x2: 226.648,
    xlinkHref: "#lg2",
    y1: 168.753,
    y2: 133.15
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 238.643,
    x2: 256.118,
    xlinkHref: "#lg5",
    y1: 145.144,
    y2: 162.62
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientTransform: "matrix(-1 0 0 -1 303.25 1436.25)",
    gradientUnits: "userSpaceOnUse",
    x1: 54.89,
    x2: 65.729,
    xlinkHref: "#lg5",
    y1: 1281.389,
    y2: 1292.227
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.37,
    x2: 147.766,
    xlinkHref: "#lg2",
    y1: 206.819,
    y2: 171.215
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 159.761,
    x2: 177.237,
    xlinkHref: "#lg5",
    y1: 183.21,
    y2: 200.685
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientTransform: "matrix(-1 0 0 -1 303.25 1436.25)",
    gradientUnits: "userSpaceOnUse",
    x1: 133.772,
    x2: 144.611,
    xlinkHref: "#lg5",
    y1: 1243.324,
    y2: 1254.162
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 222.811,
    x2: 187.207,
    xlinkHref: "#lg2",
    y1: 206.819,
    y2: 171.215
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 199.202,
    x2: 216.678,
    xlinkHref: "#lg5",
    y1: 183.21,
    y2: 200.685
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientTransform: "matrix(-1 0 0 -1 303.25 1436.25)",
    gradientUnits: "userSpaceOnUse",
    x1: 94.331,
    x2: 105.17,
    xlinkHref: "#lg5",
    y1: 1243.324,
    y2: 1254.162
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 262.252,
    x2: 226.648,
    xlinkHref: "#lg2",
    y1: 206.819,
    y2: 171.215
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 238.643,
    x2: 256.118,
    xlinkHref: "#lg5",
    y1: 183.21,
    y2: 200.685
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientTransform: "matrix(-1 0 0 -1 303.25 1436.25)",
    gradientUnits: "userSpaceOnUse",
    x1: 54.89,
    x2: 65.729,
    xlinkHref: "#lg5",
    y1: 1243.324,
    y2: 1254.162
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.37,
    x2: 147.766,
    xlinkHref: "#lg2",
    y1: 244.884,
    y2: 209.28
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 159.761,
    x2: 177.237,
    xlinkHref: "#lg5",
    y1: 221.275,
    y2: 238.751
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientTransform: "matrix(-1 0 0 -1 303.25 1436.25)",
    gradientUnits: "userSpaceOnUse",
    x1: 133.772,
    x2: 144.611,
    xlinkHref: "#lg5",
    y1: 1205.258,
    y2: 1216.097
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 222.811,
    x2: 187.207,
    xlinkHref: "#lg2",
    y1: 244.884,
    y2: 209.28
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 199.202,
    x2: 216.678,
    xlinkHref: "#lg5",
    y1: 221.275,
    y2: 238.751
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientTransform: "matrix(-1 0 0 -1 303.25 1436.25)",
    gradientUnits: "userSpaceOnUse",
    x1: 94.331,
    x2: 105.17,
    xlinkHref: "#lg5",
    y1: 1205.258,
    y2: 1216.097
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 262.252,
    x2: 226.648,
    xlinkHref: "#lg2",
    y1: 244.884,
    y2: 209.28
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 238.643,
    x2: 256.118,
    xlinkHref: "#lg5",
    y1: 221.275,
    y2: 238.751
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientTransform: "matrix(-1 0 0 -1 303.25 1436.25)",
    gradientUnits: "userSpaceOnUse",
    x1: 54.89,
    x2: 65.729,
    xlinkHref: "#lg5",
    y1: 1205.258,
    y2: 1216.097
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.37,
    x2: 147.766,
    xlinkHref: "#lg2",
    y1: 282.949,
    y2: 247.345
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 159.761,
    x2: 177.237,
    xlinkHref: "#lg5",
    y1: 259.34,
    y2: 276.816
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientTransform: "matrix(-1 0 0 -1 303.25 1436.25)",
    gradientUnits: "userSpaceOnUse",
    x1: 133.772,
    x2: 144.611,
    xlinkHref: "#lg5",
    y1: 1167.193,
    y2: 1178.032
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 222.811,
    x2: 187.207,
    xlinkHref: "#lg2",
    y1: 282.949,
    y2: 247.345
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 199.202,
    x2: 216.678,
    xlinkHref: "#lg5",
    y1: 259.34,
    y2: 276.816
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientTransform: "matrix(-1 0 0 -1 303.25 1436.25)",
    gradientUnits: "userSpaceOnUse",
    x1: 94.331,
    x2: 105.17,
    xlinkHref: "#lg5",
    y1: 1167.193,
    y2: 1178.032
  })), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 262.252,
    x2: 226.648,
    xlinkHref: "#lg2",
    y1: 282.949,
    y2: 247.345
  })), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 238.643,
    x2: 256.118,
    xlinkHref: "#lg5",
    y1: 259.34,
    y2: 276.816
  })), _linearGradient50 || (_linearGradient50 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientTransform: "matrix(-1 0 0 -1 303.25 1436.25)",
    gradientUnits: "userSpaceOnUse",
    x1: 54.89,
    x2: 65.729,
    xlinkHref: "#lg5",
    y1: 1167.193,
    y2: 1178.032
  })), _linearGradient51 || (_linearGradient51 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 227.538,
    x2: 221.118,
    xlinkHref: "#lg2",
    y1: 339.626,
    y2: 288.261
  })), _linearGradient52 || (_linearGradient52 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  }))), _linearGradient53 || (_linearGradient53 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 201.007,
    x2: 212.626,
    xlinkHref: "#lg6",
    y1: 297.541,
    y2: 334.23
  })), _linearGradient54 || (_linearGradient54 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 205.199,
    x2: 205.199,
    xlinkHref: "#lg6",
    y1: 315.976,
    y2: 306.951
  })), _linearGradient55 || (_linearGradient55 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 386.955,
    x2: 309.908,
    xlinkHref: "#lg2",
    y1: 246.932,
    y2: 223.084
  })), _linearGradient56 || (_linearGradient56 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 294.086,
    x2: 328.087,
    xlinkHref: "#lg6",
    y1: 355.466,
    y2: 389.466
  })), _linearGradient57 || (_linearGradient57 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e566e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2944,
    stopColor: "#674d66",
    stopOpacity: 0.294
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593b56"
  }))), _linearGradient58 || (_linearGradient58 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 315.746,
    x2: 313.361,
    xlinkHref: "#lg7",
    y1: 340.183,
    y2: 321.105
  })), _linearGradient59 || (_linearGradient59 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 334.493,
    x2: 320.12,
    xlinkHref: "#lg7",
    y1: 358.847,
    y2: 358.847
  })), _linearGradient60 || (_linearGradient60 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 299.333,
    x2: 308.354,
    xlinkHref: "#lg7",
    y1: 364.589,
    y2: 364.589
  })), _linearGradient61 || (_linearGradient61 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 293.969,
    x2: 342.764,
    xlinkHref: "#lg6",
    y1: 217.526,
    y2: 217.526
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m266.252 510h-22.505c-14.314 0-25.917-11.604-25.917-25.917v-110.14h74.34v110.14c0 14.313-11.604 25.917-25.918 25.917z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m217.83 448.66 59.056 59.057c9.009-4.06 15.283-13.111 15.283-23.634v-110.14h-74.34v74.717z",
    fill: "url(#SVGID_2_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m289.068 449.5h-68.136c-9.74 0-17.636-7.896-17.636-17.635v-13.365h103.407v13.365c0 9.739-7.895 17.635-17.635 17.635z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m366.743 419.819c-74.36 20.313-149.133 20.311-223.486 0-17.443-4.765-30.443-19.387-33.216-37.255-17.033-109.778-17.033-220.296 0-330.073 2.772-17.869 15.772-32.49 33.216-37.255 74.352-20.311 149.126-20.314 223.486 0 17.444 4.765 30.444 19.387 33.216 37.256 17.032 109.777 17.033 220.296 0 330.073-2.772 17.867-15.772 32.488-33.216 37.254z",
    fill: "url(#SVGID_4_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m106.989 361.532c.948 7.013 1.964 14.024 3.052 21.031 2.772 17.869 15.772 32.49 33.216 37.255 74.353 20.311 149.126 20.314 223.486 0 17.444-4.765 30.444-19.387 33.216-37.255 1.087-7.008 2.103-14.018 3.052-21.031z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m353.768 371.065c-65.726 15.418-131.818 15.416-197.537 0-15.418-3.617-26.909-14.714-29.359-28.277-15.055-83.321-15.055-167.204 0-250.524 2.451-13.562 13.941-24.66 29.359-28.277 65.719-15.416 131.811-15.418 197.537 0 15.418 3.617 26.909 14.714 29.359 28.277 15.055 83.321 15.055 167.203 0 250.524-2.45 13.563-13.94 24.66-29.359 28.277z",
    fill: "url(#SVGID_6_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m396.856 393.453-47.228-47.228h-7.222-35.124v11.485h-15.593c-13.74 0-24.918 11.178-24.918 24.918 0 7.287 3.145 13.853 8.148 18.414l30.859 30.859c20.341-2.518 40.669-6.537 60.965-12.082 13.735-3.753 24.712-13.618 30.113-26.366z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m351.017 346.225h-192.034c-14.599 0-26.433-11.835-26.433-26.433v-204.53c0-14.599 11.835-26.433 26.433-26.433h192.034c14.599 0 26.433 11.834 26.433 26.433v204.53c0 14.598-11.834 26.433-26.433 26.433z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.483 97.861h179.034c13.59 0 24.607 11.017 24.607 24.607v190.117c0 13.59-11.017 24.607-24.607 24.607h-179.034c-13.59 0-24.607-11.017-24.607-24.607v-190.117c0-13.59 11.017-24.607 24.607-24.607z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m179.529 137.986c-1.394-1.563-3.417-2.552-5.676-2.552h-16.191c-4.204 0-7.612 3.408-7.612 7.612v16.191c0 2.259.99 4.282 2.552 5.676l30.799 30.799c1.394 1.563 3.417 2.552 5.676 2.552h16.191c4.204 0 7.612-3.408 7.612-7.612v-16.191c0-2.259-.99-4.282-2.552-5.676z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m173.854 166.849h-16.191c-4.204 0-7.612-3.408-7.612-7.612v-16.191c0-4.204 3.408-7.612 7.612-7.612h16.191c4.204 0 7.612 3.408 7.612 7.612v16.191c0 4.204-3.408 7.612-7.612 7.612z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.737 141.4h10.042c2.607 0 4.721 2.114 4.721 4.721v10.042c0 2.607-2.114 4.721-4.721 4.721h-10.042c-2.607 0-4.721-2.114-4.721-4.721v-10.042c0-2.607 2.114-4.721 4.721-4.721z",
    fill: "url(#SVGID_12_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m218.97 137.986c-1.394-1.563-3.417-2.552-5.676-2.552h-16.191c-4.204 0-7.612 3.408-7.612 7.612v16.191c0 2.259.99 4.282 2.552 5.676l30.799 30.799c1.394 1.563 3.417 2.552 5.676 2.552h16.191c4.204 0 7.612-3.408 7.612-7.612v-16.191c0-2.259-.99-4.282-2.552-5.676z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m213.295 166.849h-16.191c-4.204 0-7.612-3.408-7.612-7.612v-16.191c0-4.204 3.408-7.612 7.612-7.612h16.191c4.204 0 7.612 3.408 7.612 7.612v16.191c0 4.204-3.408 7.612-7.612 7.612z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200.178 141.4h10.042c2.607 0 4.721 2.114 4.721 4.721v10.042c0 2.607-2.114 4.721-4.721 4.721h-10.042c-2.607 0-4.721-2.114-4.721-4.721v-10.042c0-2.607 2.114-4.721 4.721-4.721z",
    fill: "url(#SVGID_15_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m258.411 137.986c-1.394-1.563-3.417-2.552-5.676-2.552h-16.191c-4.204 0-7.612 3.408-7.612 7.612v16.191c0 2.259.99 4.282 2.552 5.676l30.799 30.799c1.394 1.563 3.417 2.552 5.676 2.552h16.191c4.204 0 7.612-3.408 7.612-7.612v-16.191c0-2.259-.99-4.282-2.552-5.676z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m252.735 166.849h-16.191c-4.204 0-7.612-3.408-7.612-7.612v-16.191c0-4.204 3.408-7.612 7.612-7.612h16.191c4.204 0 7.612 3.408 7.612 7.612v16.191c.001 4.204-3.408 7.612-7.612 7.612z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m239.619 141.4h10.042c2.607 0 4.721 2.114 4.721 4.721v10.042c0 2.607-2.114 4.721-4.721 4.721h-10.042c-2.607 0-4.721-2.114-4.721-4.721v-10.042c0-2.607 2.114-4.721 4.721-4.721z",
    fill: "url(#SVGID_18_)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m179.529 176.052c-1.394-1.563-3.417-2.552-5.676-2.552h-16.191c-4.204 0-7.612 3.408-7.612 7.612v16.191c0 2.259.99 4.282 2.552 5.676l30.799 30.799c1.394 1.563 3.417 2.552 5.676 2.552h16.191c4.204 0 7.612-3.408 7.612-7.612v-16.191c0-2.259-.99-4.282-2.552-5.676z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m173.854 204.914h-16.191c-4.204 0-7.612-3.408-7.612-7.612v-16.191c0-4.204 3.408-7.612 7.612-7.612h16.191c4.204 0 7.612 3.408 7.612 7.612v16.191c0 4.204-3.408 7.612-7.612 7.612z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.737 179.465h10.042c2.607 0 4.721 2.114 4.721 4.721v10.042c0 2.607-2.114 4.721-4.721 4.721h-10.042c-2.607 0-4.721-2.114-4.721-4.721v-10.042c0-2.607 2.114-4.721 4.721-4.721z",
    fill: "url(#SVGID_21_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m218.97 176.052c-1.394-1.563-3.417-2.552-5.676-2.552h-16.191c-4.204 0-7.612 3.408-7.612 7.612v16.191c0 2.259.99 4.282 2.552 5.676l30.799 30.799c1.394 1.563 3.417 2.552 5.676 2.552h16.191c4.204 0 7.612-3.408 7.612-7.612v-16.191c0-2.259-.99-4.282-2.552-5.676z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m213.295 204.914h-16.191c-4.204 0-7.612-3.408-7.612-7.612v-16.191c0-4.204 3.408-7.612 7.612-7.612h16.191c4.204 0 7.612 3.408 7.612 7.612v16.191c0 4.204-3.408 7.612-7.612 7.612z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200.178 179.465h10.042c2.607 0 4.721 2.114 4.721 4.721v10.042c0 2.607-2.114 4.721-4.721 4.721h-10.042c-2.607 0-4.721-2.114-4.721-4.721v-10.042c0-2.607 2.114-4.721 4.721-4.721z",
    fill: "url(#SVGID_24_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m258.411 176.052c-1.394-1.563-3.417-2.552-5.676-2.552h-16.191c-4.204 0-7.612 3.408-7.612 7.612v16.191c0 2.259.99 4.282 2.552 5.676l30.799 30.799c1.394 1.563 3.417 2.552 5.676 2.552h16.191c4.204 0 7.612-3.408 7.612-7.612v-16.191c0-2.259-.99-4.282-2.552-5.676z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m252.735 204.914h-16.191c-4.204 0-7.612-3.408-7.612-7.612v-16.191c0-4.204 3.408-7.612 7.612-7.612h16.191c4.204 0 7.612 3.408 7.612 7.612v16.191c.001 4.204-3.408 7.612-7.612 7.612z",
    fill: "url(#SVGID_26_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m239.619 179.465h10.042c2.607 0 4.721 2.114 4.721 4.721v10.042c0 2.607-2.114 4.721-4.721 4.721h-10.042c-2.607 0-4.721-2.114-4.721-4.721v-10.042c0-2.607 2.114-4.721 4.721-4.721z",
    fill: "url(#SVGID_27_)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m179.529 214.117c-1.394-1.563-3.417-2.552-5.676-2.552h-16.191c-4.204 0-7.612 3.408-7.612 7.612v16.191c0 2.259.99 4.282 2.552 5.676l30.799 30.799c1.394 1.563 3.417 2.552 5.676 2.552h16.191c4.204 0 7.612-3.408 7.612-7.612v-16.191c0-2.259-.99-4.282-2.552-5.676z",
    fill: "url(#SVGID_28_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m173.854 242.98h-16.191c-4.204 0-7.612-3.408-7.612-7.612v-16.191c0-4.204 3.408-7.612 7.612-7.612h16.191c4.204 0 7.612 3.408 7.612 7.612v16.191c0 4.204-3.408 7.612-7.612 7.612z",
    fill: "url(#SVGID_29_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.737 217.53h10.042c2.607 0 4.721 2.114 4.721 4.721v10.042c0 2.607-2.114 4.721-4.721 4.721h-10.042c-2.607 0-4.721-2.114-4.721-4.721v-10.042c0-2.607 2.114-4.721 4.721-4.721z",
    fill: "url(#SVGID_30_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m218.97 214.117c-1.394-1.563-3.417-2.552-5.676-2.552h-16.191c-4.204 0-7.612 3.408-7.612 7.612v16.191c0 2.259.99 4.282 2.552 5.676l30.799 30.799c1.394 1.563 3.417 2.552 5.676 2.552h16.191c4.204 0 7.612-3.408 7.612-7.612v-16.191c0-2.259-.99-4.282-2.552-5.676z",
    fill: "url(#SVGID_31_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m213.295 242.98h-16.191c-4.204 0-7.612-3.408-7.612-7.612v-16.191c0-4.204 3.408-7.612 7.612-7.612h16.191c4.204 0 7.612 3.408 7.612 7.612v16.191c0 4.204-3.408 7.612-7.612 7.612z",
    fill: "url(#SVGID_32_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200.178 217.53h10.042c2.607 0 4.721 2.114 4.721 4.721v10.042c0 2.607-2.114 4.721-4.721 4.721h-10.042c-2.607 0-4.721-2.114-4.721-4.721v-10.042c0-2.607 2.114-4.721 4.721-4.721z",
    fill: "url(#SVGID_33_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m258.411 214.117c-1.394-1.563-3.417-2.552-5.676-2.552h-16.191c-4.204 0-7.612 3.408-7.612 7.612v16.191c0 2.259.99 4.282 2.552 5.676l30.799 30.799c1.394 1.563 3.417 2.552 5.676 2.552h16.191c4.204 0 7.612-3.408 7.612-7.612v-16.191c0-2.259-.99-4.282-2.552-5.676z",
    fill: "url(#SVGID_34_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m252.735 242.98h-16.191c-4.204 0-7.612-3.408-7.612-7.612v-16.191c0-4.204 3.408-7.612 7.612-7.612h16.191c4.204 0 7.612 3.408 7.612 7.612v16.191c.001 4.204-3.408 7.612-7.612 7.612z",
    fill: "url(#SVGID_35_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m239.619 217.53h10.042c2.607 0 4.721 2.114 4.721 4.721v10.042c0 2.607-2.114 4.721-4.721 4.721h-10.042c-2.607 0-4.721-2.114-4.721-4.721v-10.042c0-2.607 2.114-4.721 4.721-4.721z",
    fill: "url(#SVGID_36_)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m179.529 252.182c-1.394-1.563-3.417-2.552-5.676-2.552h-16.191c-4.204 0-7.612 3.408-7.612 7.612v16.191c0 2.259.99 4.282 2.552 5.676l30.799 30.799c1.394 1.563 3.417 2.552 5.676 2.552h16.191c4.204 0 7.612-3.408 7.612-7.612v-16.191c0-2.259-.99-4.282-2.552-5.676z",
    fill: "url(#SVGID_37_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m173.854 281.045h-16.191c-4.204 0-7.612-3.408-7.612-7.612v-16.191c0-4.204 3.408-7.612 7.612-7.612h16.191c4.204 0 7.612 3.408 7.612 7.612v16.191c0 4.204-3.408 7.612-7.612 7.612z",
    fill: "url(#SVGID_38_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.737 255.595h10.042c2.607 0 4.721 2.114 4.721 4.721v10.042c0 2.607-2.114 4.721-4.721 4.721h-10.042c-2.607 0-4.721-2.114-4.721-4.721v-10.042c0-2.607 2.114-4.721 4.721-4.721z",
    fill: "url(#SVGID_39_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m218.97 252.182c-1.394-1.563-3.417-2.552-5.676-2.552h-16.191c-4.204 0-7.612 3.408-7.612 7.612v16.191c0 2.259.99 4.282 2.552 5.676l30.799 30.799c1.394 1.563 3.417 2.552 5.676 2.552h16.191c4.204 0 7.612-3.408 7.612-7.612v-16.191c0-2.259-.99-4.282-2.552-5.676z",
    fill: "url(#SVGID_40_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m213.295 281.045h-16.191c-4.204 0-7.612-3.408-7.612-7.612v-16.191c0-4.204 3.408-7.612 7.612-7.612h16.191c4.204 0 7.612 3.408 7.612 7.612v16.191c0 4.204-3.408 7.612-7.612 7.612z",
    fill: "url(#SVGID_41_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200.178 255.595h10.042c2.607 0 4.721 2.114 4.721 4.721v10.042c0 2.607-2.114 4.721-4.721 4.721h-10.042c-2.607 0-4.721-2.114-4.721-4.721v-10.042c0-2.607 2.114-4.721 4.721-4.721z",
    fill: "url(#SVGID_42_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m258.411 252.182c-1.394-1.563-3.417-2.552-5.676-2.552h-16.191c-4.204 0-7.612 3.408-7.612 7.612v16.191c0 2.259.99 4.282 2.552 5.676l30.799 30.799c1.394 1.563 3.417 2.552 5.676 2.552h16.191c4.204 0 7.612-3.408 7.612-7.612v-16.191c0-2.259-.99-4.282-2.552-5.676z",
    fill: "url(#SVGID_43_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m252.735 281.045h-16.191c-4.204 0-7.612-3.408-7.612-7.612v-16.191c0-4.204 3.408-7.612 7.612-7.612h16.191c4.204 0 7.612 3.408 7.612 7.612v16.191c.001 4.204-3.408 7.612-7.612 7.612z",
    fill: "url(#SVGID_44_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m239.619 255.595h10.042c2.607 0 4.721 2.114 4.721 4.721v10.042c0 2.607-2.114 4.721-4.721 4.721h-10.042c-2.607 0-4.721-2.114-4.721-4.721v-10.042c0-2.607 2.114-4.721 4.721-4.721z",
    fill: "url(#SVGID_45_)"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "m302.907 346.225-43.626-43.626c-.991-1.342-2.579-2.215-4.375-2.215h-99.411c-3.006 0-5.443 2.437-5.443 5.443v9.905c0 1.796.874 3.384 2.215 4.375l26.119 26.119h124.521z",
    fill: "url(#SVGID_46_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m254.905 321.173h-99.411c-3.006 0-5.443-2.437-5.443-5.443v-9.905c0-3.006 2.437-5.443 5.443-5.443h99.411c3.006 0 5.443 2.437 5.443 5.443v9.905c0 3.007-2.437 5.443-5.443 5.443z",
    fill: "url(#SVGID_47_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.364 307.192h95.671c1.696 0 3.072 1.375 3.072 3.072v1.03c0 1.696-1.375 3.072-3.072 3.072h-95.671c-1.696 0-3.072-1.375-3.072-3.072v-1.03c0-1.697 1.375-3.072 3.072-3.072z",
    fill: "url(#SVGID_48_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m309.634 346.225h41.384c14.599 0 26.433-11.835 26.433-26.433v-171.888l-33.985-33.985c-5.054-5.722-12.959-9.594-22.023-10.176-4.854-.312-9.71-.312-14.564 0-14.632.94-26.387 10.44-27.715 22.514-1.338 12.168-1.338 24.365 0 36.533.598 5.44 3.314 10.356 7.456 14.202.277.257.541.526.808.792.22.241.46.469.691.704 5.914 6.248 9.175 14.595 9.175 23.253v31.571c0 9.367-3.809 18.375-10.674 24.749-4.142 3.846-6.858 8.762-7.457 14.202-1.338 12.168-1.338 24.365 0 36.533.623 5.666 3.543 10.765 7.979 14.679l20.14 20.209v2.541z",
    fill: "url(#SVGID_49_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m296.122 407.546h-4.433c-13.74 0-24.918-11.178-24.918-24.918s11.179-24.918 24.918-24.918h15.593v-34.406h13.758v34.406h3.344c6.333 0 11.485-5.152 11.485-11.485h13.758c0 13.919-11.324 25.244-25.244 25.244h-3.344v11.16c.002 13.739-11.177 24.917-24.917 24.917zm-4.433-36.078c-6.154 0-11.16 5.006-11.16 11.16 0 6.153 5.006 11.159 11.16 11.159h4.433c6.154 0 11.16-5.006 11.16-11.159v-11.16z",
    fill: "url(#SVGID_50_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m321.041 323.304h-13.759v8.409l13.759 13.759z",
    fill: "url(#SVGID_51_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m324.384 357.71h-3.344v13.758h3.344c13.92 0 25.244-11.324 25.244-25.244h-13.758c-.001 6.334-5.153 11.486-11.486 11.486z",
    fill: "url(#SVGID_52_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m293.83 357.71h13.453v13.758h-13.453z",
    fill: "url(#SVGID_53_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m331.029 233.359v-31.666c0-9.304 3.703-18.315 10.539-24.625 4.24-3.913 7.012-8.943 7.616-14.504 1.305-12.018 1.305-24.064 0-36.082-1.32-12.16-13.007-21.793-27.742-22.739-4.854-.312-9.71-.312-14.564 0-14.632.94-26.387 10.44-27.715 22.514-1.338 12.168-1.338 24.365 0 36.533.598 5.44 3.314 10.356 7.457 14.202 6.864 6.374 10.674 15.382 10.674 24.749v31.571c0 9.367-3.81 18.375-10.674 24.749-4.142 3.846-6.858 8.762-7.457 14.202-1.338 12.168-1.338 24.365 0 36.533 1.327 12.074 13.083 21.574 27.715 22.514 4.854.312 9.71.312 14.564 0 14.735-.946 26.422-10.579 27.742-22.739 1.305-12.018 1.305-24.064 0-36.082-.604-5.56-3.376-10.59-7.616-14.504-6.836-6.311-10.539-15.322-10.539-24.626z",
    fill: "url(#SVGID_54_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPayphone);
export default __webpack_public_path__ + "static/media/icon-payphone.9651a6be6cc1e60ab51cd422f8eb3856.svg";
export { ForwardRef as ReactComponent };